import React from 'react';
import { Clock } from 'lucide-react';

export default function ComingSoonPane({ title, blurb }) {
  return (
    <div
      className="rounded-2xl p-10 text-center"
      style={{ background: '#FAFBF9', border: '1px dashed #BCC5B5' }}
      data-testid="phenoscan-coming-soon"
    >
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-5"
        style={{ background: '#FEF3C7', color: '#92400E', fontSize: 12, fontWeight: 600 }}>
        <Clock size={13} /> Coming in next release
      </div>
      <h2 className="font-display text-2xl mb-2" style={{ color: '#1B4332' }}>{title}</h2>
      <p className="mx-auto max-w-[640px] text-sm" style={{ color: '#4F4B44' }}>{blurb}</p>
      <p className="mt-5 text-xs" style={{ color: '#8A8580' }}>
        This sub-tab is part of the PhenoScan roadmap. The pipeline, data schema and hand-offs are wired —
        the per-module algorithms ship in the next phase.
      </p>
    </div>
  );
}
